import React, { Component } from 'react';
import Clappr from 'clappr';
import { sendData } from '../../analytics/sendData';
import ClapprStatsLite from './ClapprStatsLite';

class ClapprPlayer extends Component {
    componentDidMount() {
        this.change(this.props.source, this.props.poster);
    }

    componentWillUnmount() {
        this.destroyPlayer();
    }

    shouldComponentUpdate(nextProps, nextState) {
        let changed = (nextProps.source != this.props.source);
        this.props = nextProps;
        this.state = nextState;
        if (changed) {
            this.change(nextProps.source, nextProps.poster);
        }
        return false;

    }

    destroyPlayer() {
        if (this.player) {
            this.player.destroy();
        }
        this.player = null;
    }

    change(source, poster) {
        const { rid, vname, vcategory } = this.props.data;

        if (this.player) {
            this.destroyPlayer();
        }
        if(this.refs.player != null && source != ''){
            if (this.player) {
                this.destroyPlayer();
            }
            this.player = new Clappr.Player({
                parent: this.refs.player,
                plugins: [ClapprStatsLite ],
                source: source,
                poster: poster,
                mute: false,
                width: '100%',
                height: '100%',
                autoPlay:true,
                events: {
                    onError: function (error) {
                        sendData(rid, vname, vcategory, 'watched', {
                            "url": window.location.href,
                            "error": true,
                            "error_message": error.UI.message
                        }) 
                    },
                },
                clapprStatsLite: {
                    onReport: (metrics) => { 
                        const { timers, counters, extra } = metrics;
                        const watched = Math.floor(timers.watch / 1000);
                        const duration = Math.floor(extra.duration / 1000);
                        const buffers = counters.buffering;
                        const plays = counters.play;
                        const pauses = counters.pause;
                        const seeks = counters.seek;

                        sendData(rid, vname, vcategory, 'watched', {
                            "watched": watched,
                            "duration": duration,
                            "finished": watched >= duration? true : false,
                            "plays": plays,
                            "pauses": pauses,
                            "seeks": seeks,
                            "buffers": buffers
                        });
                    },
                }
            });
            if (this.player.isReady) {
                this.player.on('ready', function(){
                    this.player.play();
                });
            }

        }

    }

    render() {
        return (
            <div className="video-player">
                <div style={{height: '100%'}} ref="player"></div>
            </div>
        );
    }
}

export default ClapprPlayer;



// WEBPACK FOOTER //
// ./src/components/ClapprPlayer/ClapprPlayer.js